<template>
  <div :class="$style.container">
    <Form :counterpartie="counterpartie" readonly />
    <div :class="$style.files">
      <File
        v-for="file in counterpartie.requisites"
        :key="file.file"
        :file="file"
        readonly
      />
    </div>
    <Employes
      v-if="counterpartie.counterparty_contacts.length"
      :itemEmployes="counterpartie.counterparty_contacts"
      readonly
    />
    <Events
      v-if="counterpartie.event_logs.length"
      :items="counterpartie.event_logs"
      readonly
    />
  </div>
</template>

<script>
import Form from "./Form.vue";
import Employes from "./Employes.vue";
import File from "../common/File.vue";
import Events from "./Events.vue";
export default {
  components: {
    Form,
    Employes,
    File,
    Events,
  },
  props: {
    counterpartie: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" module>
.container {
  background-color: $bg-primary;
  padding: 1.5rem;
  .files {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin: 1.5rem 0 0 0;
  }
}
</style>
